export default function Spacer(): JSX.Element {
  return <div style={style.spacer} />
}

const style = {
  spacer: { height: '40px' },
}
